<p class="text">
  {{ payload.text }}
</p>

<div class="flex">
  <rx-button class="blue" *ngIf="payload?.buttons?.accept" (click)="acceptClicked()">
    {{ payload?.buttons?.accept?.text }}
  </rx-button>

  <rx-button class="gray" *ngIf="payload?.buttons?.deny" (click)="denyClicked()">
    {{ payload?.buttons?.deny?.text }}
  </rx-button>

  <rx-button class="gray" *ngIf="payload?.buttons?.preferences" (click)="preferencesClicked()">
    {{ payload?.buttons?.preferences?.text }}
  </rx-button>
</div>

<div class="flex links">
  <a href="https://www.patientnow.com/cookie-policy-eu/" target="blank">Cookie Policy</a>
  <a href="https://www.patientnow.com/privacy-policy-2/" target="blank">Privacy Policy</a>
</div>
